import { createContext, useContext } from 'react';
export const CopyTextAreaContext = /*#__PURE__*/createContext(undefined);
const {
  Consumer,
  Provider
} = CopyTextAreaContext;
export { Consumer as CopyTextAreaContextConsumer, Provider as CopyTextAreaContextProvider };
export { Consumer };
export const useCopyTextAreaContext = () => {
  const state = useContext(CopyTextAreaContext);
  if (!state) {
    // If the component is not wrapped in TextAreaProvider, return undefined
    return undefined;
  }
  return state;
};